<template>
  <div>
    <div class="title">配送时间？</div>
    <div class="content-info">
      <p class="txt1">早7点至早11点。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
